/*
 * @Author: cmchiu
 * @Date: 2022-04-14 15:28:12
 * @LastEditTime: 2022-08-15 09:48:39
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \campus2022\campus2022-ClientApp\src\api\campus.js
 *
 */
import request from '@/utils/request'

export const getEmergencyContact = params => {
    return request({
        url: '/EdurpColl/GetCampus_EmergencyContact',
        method: 'get',
        params,
    })
}

export const getEdurpColl = params => {
    return request({
        url: '/EdurpColl/GetEdurpColl',
        method: 'get',
        params,
    })
}

export const getBannerList = params => {
    return request({
        url: '/Banner/GetBannerList',
        method: 'get',
        params,
        timeout: 300000,
    })
}

export const getRunBanner = params => {
    return request({
        url: '/Banner/GetRunBanner',
        method: 'get',
        params,
        timeout: 300000,
    })
}

export const getBlockSubType = params => {
    return request({
        url: '/News/GetBlockSubType',
        method: 'get',
        params,
        timeout: 300000,
    })
}

export const getNewsList = params => {
    return request({
        url: '/News/GetNewsList',
        method: 'get',
        params,
        timeout: 300000,
    })
}

export const getNewsContent = params => {
    return request({
        url: '/News/GetNewsContent',
        method: 'get',
        params,
        timeout: 300000,
    })
}

export const getBoardListData = params => {
    return request({
        url: '/News/GetBoardListData',
        method: 'get',
        params,
        timeout: 300000,
    })
}

export const getBoardList = params => {
    return request({
        url: '/News/GetBoardList',
        method: 'get',
        params,
        timeout: 300000,
    })
}

export const getNewActiveList = params => {
    return request({
        url: '/NewActive/GetNewActiveList',
        method: 'get',
        params,
        timeout: 300000,
    })
}

export const getUrgentNotice = params => {
    return request({
        url: '/Notice/GetUrgentNotice',
        method: 'get',
        params,
        timeout: 300000,
    })
}

export const getEventList = params => {
    return request({
        url: '/Calendar/GetEventList',
        method: 'get',
        params,
        timeout: 300000,
    })
}

export const getRangeEvents = params => {
    return request({
        url: '/Calendar/GetRangeEvents',
        method: 'get',
        params,
        timeout: 300000,
    })
}

export const getMenuData = params => {
    return request({
        url: '/Menu/GetMenuData',
        method: 'get',
        params,
        timeout: 300000,
    })
}

const campus = {
    getEmergencyContact,
    getEdurpColl,
    getBannerList,
    getRunBanner,
    getBlockSubType,
    getNewsList,
    getNewsContent,
    getBoardListData,
    getBoardList,
    getNewActiveList,
    getUrgentNotice,
    getEventList,
    getRangeEvents,
    getMenuData,
}
export default campus
